import React from "react";
import Hero from './FPVRacing/Hero';
import MagicBento from './FPVRacing/MagicBento';
import CertificationMumbaiChandigarh from "./CertificationMumbaiChandigarh";
import WhoCanApply from "./WhoCanApply";

const FPVRacing = () => {

  return (
    <>
      <Hero />
      <WhoCanApply />
      <MagicBento />
      <CertificationMumbaiChandigarh />
    </>
  );
};

export default FPVRacing;
